import { WEBINAR_CONFIG } from 'src/constants/api';
import { REF_TAG } from 'src/constants/refTag';
import { DEFAULT_MASKED_USER_ID, DEFAULT_DURATION_MINUTES, FALLBACK_TIMEZONE } from 'src/constants/webinar';
import { RegisterUserForWebinarRequest } from 'src/types/api/webinars';
import { WebinarData } from 'src/types/state/webinar';
import { getUserTimezone } from './webinarDataTransformer';

/**
 * Builds a complete webinar registration request payload according to backend API structure
 * Since the registration is just building a payload and not doing processing, we can use
 * placeholder values for webinarTimezone as the backend doesn't process it.
 * @param webinar - Webinar data from UI state
 * @param clientId - Client ID (optional, will use default from config if not provided)
 * @param maskedUserId - Masked user ID (optional, will use default if not provided)
 * @param refTag - Reference tag (optional, will use default if not provided)
 * @returns Complete registration request object with nested structure
 */
export const buildWebinarRegistrationRequest = (
  webinar: WebinarData,
  clientId?: string,
  maskedUserId?: string,
): RegisterUserForWebinarRequest => {
  return {
    webinarRegistrant: {
      maskedUserId: maskedUserId || DEFAULT_MASKED_USER_ID,
      userTimezone: webinar.userTimezone || getUserTimezone() || FALLBACK_TIMEZONE,
      registrationUrl: '',
    },
    webinar: {
      webinarId: webinar.webinarId,
      webinarTimezone: webinar.userTimezone || getUserTimezone() || FALLBACK_TIMEZONE,
      webinarScheduledUTCTimestamp: webinar.webinarScheduledTimestamp,
      isRegistered: true, // Set to true for registration request
      title: webinar.title,
      description: webinar.description || '',
      webinarDuration: webinar.duration || DEFAULT_DURATION_MINUTES, // Default duration if zero
      registrationUrl: '',
    },
    webinarClientId: clientId || WEBINAR_CONFIG.CLIENT_ID,
    refTag: REF_TAG.WEBINAR_PAGE_CARD,
  };
};
